import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '4362858813925700';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      if (window.fbq) {
        // already initialized — just track a PageView
        window.fbq('track', 'PageView');
        return;
      }
      // Meta Pixel bootstrap — set up the fbq queue
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Inject the Pixel script — guard against missing DOM containers
      const target = document.head || document.body || document.documentElement;
      if (!target) return;
      // Avoid duplicate injection on hot-reload
      const existing = document.querySelector('script[src*="connect.facebook.net/en_US/fbevents.js"]');
      if (!existing) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        target.appendChild(script);
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (err) {
      // Don't let analytics break the page
      console.warn('[MetaPixel] init failed:', err);
    }
  }, []);
  return <noscript data-id="element-129">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-130" />
    </noscript>;
}